module.exports = __webpack_public_path__ + "img/blank-avatar.425d092e.png";